import {Typography} from "@mui/material";
import React, {PropsWithChildren} from "react";

export interface Props {
    color?: "initial" | "inherit" | "primary" | "secondary";
}

export const FieldTableCell: React.FC<PropsWithChildren<Props>> = ({color, children}) => {
    return (
        <Typography noWrap fontSize={14} color={color}>
            {children}
        </Typography>
    );
};
